import { AVAILABLE_CURRENCY_CODES } from 'growth-monetization-service-types';
import { Products } from 'merchandise-lib/constants/Product';
import VersionNumbers from 'self-service-api/constants/VersionNumbers';
const ProductsSet = new Set(Object.values(Products));
export const isValidApiName = apiName => {
  return apiName !== null && apiName !== undefined && typeof apiName === 'string' && ProductsSet.has(apiName);
};
export function assertIsValidApiName(apiName) {
  if (!isValidApiName(apiName)) {
    throw new Error(`Invalid ApiName: ${String(apiName)}`);
  }
}
export const isValidQuantityPackApiName = quantityPackApiName => {
  return typeof quantityPackApiName === 'string' && ['additional-marketing-contacts', 'additional-sales-seats', 'additional-service-seats', 'additional-commerce-seats', 'additional-legacy-contacts'].includes(quantityPackApiName);
};
export const isValidProductLevel = level => {
  return level !== null && level !== undefined && typeof level === 'string' && ['FREE', 'STARTER', 'PROFESSIONAL', 'ENTERPRISE'].includes(level);
};
export const isValidPaidProductLevel = level => {
  return level !== null && level !== undefined && typeof level === 'string' && ['STARTER', 'PROFESSIONAL', 'ENTERPRISE'].includes(level);
};
export const isValidSku = sku => {
  return typeof sku === 'object' && sku !== null && 'skuType' in sku;
};
export const isQuantityPackDetails = sku => {
  return isValidSku(sku) && sku.skuType === 'QUANTITY_PACK';
};
export const isProductVersion = sku => {
  return isValidSku(sku) && sku.skuType === 'PRODUCT_VERSION';
};
export const isCoreSeatsApiName = apiName => {
  return [Products.CORE_SEATS_INCLUDED_STARTER, Products.CORE_SEATS_STARTER, Products.CORE_SEATS_PROFESSIONAL, Products.CORE_SEATS_ENTERPRISE].includes(apiName);
};
export const isValidProductLine = productLine => {
  return productLine !== null && productLine !== undefined && typeof productLine === 'string' && ['MARKETING', 'SALES', 'SERVICE', 'CMS', 'OPERATIONS', 'COMMERCE'].includes(productLine);
};

// TODO - update to use release insights instead of version number
export const isInVersionNumbers = apiName => {
  return apiName in VersionNumbers;
};
export const isFilteredProductResponse = product => {
  return isValidApiName(product.apiName);
};
export function isAvailableCurrencyCode(value) {
  return value !== undefined && value !== null && typeof value === 'string' && value in AVAILABLE_CURRENCY_CODES;
}